import gql from 'graphql-tag';
import TASK_FRAGMENT from 'graph/fragments/task';

export default gql`
  query exercises($startDate: String!, $endDate: String!) {
    exercises (startDate: $startDate, endDate: $endDate) {
      ...task
    }
  }
  ${TASK_FRAGMENT}
`;
